"use client"

/* eslint-disable no-nested-ternary */
import clsx from "clsx"
import Image from "next/image"
import Link from "next/link"
import React, { useContext } from "react"

import ButtonArrow from "../../../public/button-arrow.svg"
import LocationIcon from "../../../public/icons/quote-location-pin.svg"
import QuoteMark from "../../../public/icons/quotemarks.svg"

import PageThemeContext from "./page-theme/PageThemeContext"

interface TextProps {
  showQuotee?: boolean
  quote?: string
  name?: string
  quoteeDescription?: string
  quoteeImage?: {
    url: string
    title: string
  }
  fontSizeBig?: boolean
  caseStudyLink?: boolean
  quoteMarkColor?: string
  textColorOverrideClass?: string
  location?: string
  customersPageLink?: boolean
}

const Quote: React.FC<TextProps> = ({
  showQuotee = false,
  quote,
  name,
  quoteeDescription = null,
  quoteeImage,
  caseStudyLink = false,
  fontSizeBig = true,
  quoteMarkColor = "fill-blue-50",
  textColorOverrideClass = null,
  location = null,
  customersPageLink = false,
}) => {
  const pageThemeContext = useContext(PageThemeContext)
  const textColorClass = pageThemeContext.pageTheme.dark
    ? textColorOverrideClass !== null
      ? textColorOverrideClass
      : "text-gray-2.5"
    : textColorOverrideClass !== null
      ? textColorOverrideClass
      : "text-gray-90"
  return (
    <>
      <QuoteMark alt="Quotemarks" className={quoteMarkColor} />
      <p
        className={clsx(
          "mt-8",
          textColorClass,
          fontSizeBig ? "body2 md:body1" : "body3",
        )}
      >
        {quote}
      </p>
      <div className="flex items-center mt-6">
        {showQuotee && quoteeImage && (
          <Image
            src={quoteeImage.url}
            alt={name || "Quote Person"}
            className="w-16 h-16 mr-4 object-cover rounded-2xl"
            width={64}
            height={64}
          />
        )}
        <p
          className={clsx(
            "uppercase caption2 whitespace-normal max-w-[610px]",
            textColorClass,
            fontSizeBig && "md:caption1",
          )}
        >
          {name}
          {quoteeDescription ? (
            <>
              <br />
              {quoteeDescription}
            </>
          ) : null}
        </p>
      </div>
      {location && (
        <p className="flex items-center mt-4 textColorClass body3">
          <LocationIcon className="mr-4" />
          {location}
        </p>
      )}
      {caseStudyLink && (
        <div className="pt-8">
          <p className="absolute bottom-8 text-gray-85">
            Read More <ButtonArrow />
          </p>
        </div>
      )}
      {customersPageLink && (
        <Link
          href="/customers/"
          className="flex items-center mt-16 text-blue-55"
        >
          Hear from more customers <ButtonArrow />
        </Link>
      )}
    </>
  )
}

export default Quote
